import { setActiveService } from "../../../utilities/activeService";
import { getWorkerImportURL } from "../../../utilities/getWorkerImportURL";
import { setNextRefresh } from "../../../utilities/nextRefresh";
import { refresh } from "../refresh/refresh";
import { handleCountdown } from "./handleCountdown";
// TODO: What if it doesn't load?
const fileName = "/timers.thread.js";
const workerURL = process.env.NODE_ENV == "development"
    ? `.${fileName}`
    : getWorkerImportURL(`https://xml.cedarparkchurchofchrist.org/bulletin-board${fileName}`);
// Listen for a countdown finished
export function watchTimers() {
    return new Promise((resolve) => {
        const timersWorker = new Worker(workerURL);
        timersWorker.postMessage({
            type: 0 /* TimerMessageTypes.ExecuteWorker */,
            url: window.location.href,
        });
        timersWorker.onmessage = (e) => {
            const { type, timerData, activeService, nextRefresh } = e.data;
            switch (type) {
                case 1 /* TimerMessageTypes.Countdown */:
                    handleCountdown(timerData);
                    break;
                case 2 /* TimerMessageTypes.Refresh */:
                    refresh();
                    break;
                case 3 /* TimerMessageTypes.Initial */:
                    activeService && setActiveService(activeService);
                    nextRefresh && setNextRefresh(nextRefresh);
                    resolve(undefined);
                    break;
                default:
                    break;
            }
        };
    });
}
